import React, { useEffect, useState } from "react";
import { useSpring, animated } from "@react-spring/web";

function RollingNumber({
  initialNumber = 0,
  finalNumber = 500,
  interval = 5000,
  fontSize = 48,
}) {
  const [number, setNumber] = useState(initialNumber);

  // spring animation setup
  const { animatedNumber } = useSpring({
    from: { animatedNumber: initialNumber },
    to: { animatedNumber: number },
    config: {
      tension: 100,   // controls bounciness
      friction: 20,   // controls resistance
    },
  });

  useEffect(() => {
    const animate = () => {
      setNumber(initialNumber);

      setTimeout(() => {
        setNumber(finalNumber);
      }, 500);
    };

    animate();
    const loop = setInterval(animate, interval);

    return () => clearInterval(loop);
  }, [initialNumber, finalNumber, interval]);

  return (
    <div
      className="font-bold text-[#B20925]"
      style={{ fontSize: `${fontSize}px` }}
    >
      <animated.span>
        {animatedNumber.to((n) => Math.floor(n))}
      </animated.span>
    </div>
  );
}

export default RollingNumber;
